<div class="container">
  <div #fullnav class="wrapper">
    <div class="header">
      <h3>SHANNON SCHULTZ PHOTO</h3>
    </div>
    <div></div>
    <div class="grid-container">
      <ul>
        <li *ngFor="let f of folders">
          <a
            routerLink="/display"
            (click)="setFolder(f)"
            routerLinkActive="active"
            >{{ f.title }}</a
          >
        </li>
        <li>
          <a routerLink="/bio" routerLinkActive="active">Bio</a>
        </li>
        <li>
          <a routerLink="/contact" routerLinkActive="active">Contact</a>
        </li>
        <li>
          <a routerLink="/console" routerLinkActive="active">Console</a>
        </li>
      </ul>
    </div>
  </div>
  <main class="content">
    <router-outlet></router-outlet>
  </main>
</div>
